import { ReactNode } from 'react';

import { generateChips } from '@/plp/components/PlpFilterChips/PlpFilterChips.helpers';

import { RecentFilterSearch } from './RecentSearch.type';

export const getFilter = (search: RecentFilterSearch) => {
  const chips = generateChips(search.filters);

  let caption: ReactNode = '';
  let title: ReactNode = '';

  if (chips.length > 1) {
    caption = chips[1].label;
  }

  if (chips.length) {
    title = chips[0].label;
  }

  return { title: title, caption: caption };
};
